<ion-grid>
    <ion-row>
        <ion-col id="projectTask2" size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item lines="none" mode="ios" [disabled]="disabled">
                <ion-col size="12">
                    <ion-label id="projectTask3" mode="ios" position="stacked" class="btn-input list__select-field-label">Project
                    </ion-label>
                    <ion-label *ngIf="!isProjectsLoading; else projectsLoading" id="projectTask4" class="projectLabel" (click)="openProjectModal()">{{selectedProject?.NameAndNumber}}
                        <span>
                            <ion-icon name="caret-down"></ion-icon>
                        </span>
                    </ion-label>
                    <ng-template #projectsLoading>
                        <ion-skeleton-text animated style="width: 100%; height: 40px;"></ion-skeleton-text>
                    </ng-template>
                </ion-col>
            </ion-item>
        </ion-col>
    </ion-row>

    <ion-row id="projectTask1"  *ngIf="useFieldActivities">
        <ion-col id="projectTask5" size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item id="projectTask6" lines="none" mode="ios" [disabled]="!selectedProject">
                <ion-col id="projectTask7" size="12">
                    <ion-label id="projectTask8" mode="ios" position="stacked" class="btn-input list__select-field-label">Position</ion-label>
                    <ion-label *ngIf="!isFieldActivitiesLoading; else fieldActivitiesLoading" id="projectTask9" class="projectLabel" (click)="openFieldActivityModal()">
                        {{selectedFieldActivity?.ActivityName}}
                        <span>
                            <ion-icon id="projectTask10" name="caret-down"></ion-icon>
                        </span>
                    </ion-label>
                    <ng-template #fieldActivitiesLoading>
                        <ion-skeleton-text animated style="width: 100%; height: 40px;"></ion-skeleton-text>
                    </ng-template>
                </ion-col>
            </ion-item>
        </ion-col>
    </ion-row>

    <ion-row id="projectTask11" *ngIf="!useFieldActivities">
        <ion-col id="projectTask18" *ngIf="showTaskTypeFilterButtons" size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item id="projectTask19" lines="none" mode="ios" class="btn-input" [disabled]="!selectedProject">
                <ion-segment id="projectTask20" [(ngModel)]="taskTypeFilter" (ionChange)="setTaskFilterType(taskTypeFilter)">
                  <ion-segment-button id="projectTask21" value="APN">APN</ion-segment-button>
                  <ion-segment-button id="projectTask22" value="Community">Community</ion-segment-button>
                </ion-segment>
            </ion-item>
        </ion-col>
        <ion-col id="projectTask24" size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item id="projectTask25" lines="none" mode="ios" [disabled]="!selectedProject">
                <ion-col id="projectTask26" size="12">
                    <ion-label id="projectTask27" mode="ios" position="stacked" class="btn-input list__select-field-label">Task</ion-label>
                    <ion-label *ngIf="!isTasksLoading; else tasksLoading" id="projectTask28" class="projectLabel" (click)="openTaskModal()">
                        {{selectedTask?.NameAndNumber}}
                        <span><ion-icon name="caret-down"></ion-icon></span>
                    </ion-label>
                    <ng-template #tasksLoading>
                        <ion-skeleton-text animated style="width: 100%; height: 40px;"></ion-skeleton-text>
                    </ng-template>
                </ion-col>
            </ion-item>
        </ion-col>
        <ion-col size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item lines="none" mode="ios" [disabled]="!selectedProject">
                <ion-col size="12">
                    <ion-label mode="ios" position="stacked" class="btn-input list__select-field-label">Labor Category</ion-label>
                    <ion-label *ngIf="!isLaborCategoriesLoading; else laborCategoriesLoading" id="projectTask29" class="projectLabel" (click)="openLaborCategoryModal()">
                        {{selectedLaborCategory?.NameAndNumber}}
                        <span><ion-icon name="caret-down"></ion-icon></span>
                    </ion-label>
                    <ng-template #laborCategoriesLoading>
                        <ion-skeleton-text animated style="width: 100%; height: 40px;"></ion-skeleton-text>
                    </ng-template>
                </ion-col>
            </ion-item>
        </ion-col>
    </ion-row>

    <ion-row>
        <ion-col id="projectTask30" size-lg="12" size-md="12" size-sm="12" size="12" class="change-project">
            <ion-item  id="projectTask31" lines="none" mode="ios" [disabled]="disabled">
                <ion-col id="projectTask32" size="12">
                    <ion-label id="projectTask33" mode="ios" class="btn-input list__select-field-label" position="stacked">Work State</ion-label>
                    <ion-label *ngIf="!isFipsStatesLoading; else fipsStatesLoading" id="projectTask34" class="projectLabel" (click)="openFipsStateModal()">
                        {{selectedFipsState?.Name}}
                        <span><ion-icon id="projectTask35" name="caret-down"></ion-icon></span>
                    </ion-label>
                    <ng-template #fipsStatesLoading>
                        <ion-skeleton-text animated style="width: 100%; height: 40px;"></ion-skeleton-text>
                    </ng-template>
                </ion-col>
            </ion-item>
        </ion-col>
    </ion-row>
</ion-grid>
